<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>{{toc.id != null && toc.id.length > 0 ? "Edit Train Operating Company" : "Add Train Operating Company"}}</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>
<form (ngSubmit)="saveTOC()">
    <div mat-dialog-content class="example-container">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Name <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Name"
                                [formControl]="name" name="name" [(ngModel)]="toc.name" />
                        <mat-error *ngIf="name.invalid">Name is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Code <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Code"
                                [formControl]="code" name="email" [(ngModel)]="toc.code" />
                        <mat-error *ngIf="code.invalid">Code is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <mat-label>Logo <span class="required">*</span></mat-label>
                    <div class="upload-card">
                        <img *ngIf="!previewUrl"  src="./assets/images/logo-placeholder.jpg" alt="">
                        <img *ngIf="previewUrl" [src]="previewUrl" alt="Preview" class="preview-image" />
                        <input
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            id="fileInput"
                            hidden
                            #fileInput
                            (change)="onFileSelected($event)"
                        />
                        
                        <button type="button" mat-raised-button color="primary" (click)="fileInput.click()" class="btn-outline-black me-3">
                            <mat-icon>upload</mat-icon>
                            Select Image
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="row">
        <div class="col-12">
            <div class="text-center py-3 d-flex  justify-content-center"> 
                <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="btn-outline-black me-3">Cancel </button>
                <button mat-raised-button color="primary" type="submit" class=" btn-black ">Save </button>&nbsp;&nbsp;                
            </div>
        </div>
    </div>
</form>
